var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoArrowAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM7.78407 16.8868C7.97346 17.0147 8.17336 17.0342 8.38379 16.9454L18.1055 12.6161C18.3685 12.494 18.5 12.2887 18.5 12.0001C18.5 11.7114 18.3685 11.5061 18.1055 11.384L8.38379 7.05471C8.17336 6.9659 7.97346 6.98522 7.78407 7.11265C7.59469 7.24053 7.5 7.42658 7.5 7.67079V10.1518C7.5 10.3072 7.54209 10.446 7.62626 10.5681C7.71043 10.6902 7.82616 10.7679 7.97346 10.8012L12.5502 12.0001L7.97346 13.1989C7.82616 13.2322 7.71043 13.3099 7.62626 13.432C7.54209 13.5542 7.5 13.6929 7.5 13.8483V16.3293C7.5 16.5735 7.59469 16.7594 7.78407 16.8868Z",
    fill: "#F99C4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowAlert);
export default __webpack_public_path__ + "static/media/ico-arrow-alert.d8263d7357bbbe0c2514264a3588c7d3.svg";
export { ForwardRef as ReactComponent };